import React from 'react'

const Manual_editar_sucursales_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Como editar sucursales en Clau
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a modificar la información de tus sucursales desde el panel de configuración de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_editar_sucursales_en_Clau__TyJA-eoHR-GVkdfSipOfjQ?as=scrollable"
          className="scribe-iframe-general-98"
          width="100%"
          height="12000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_editar_sucursales_clau
